const getTimeBlocksData = (timeBlocks: number[][]) => {
  return timeBlocks.length > 0
    ? timeBlocks.map((timeBlock) => timeBlock.join(','))
    : [0];
};

export default getTimeBlocksData;
